module.exports = __webpack_public_path__ + "img/bj002-001.d0df07d3.jpg";